import React from "react";
import { useDeviceType } from "@lululemon/ecom-site/src/util/with-device-characteristics";
import CTABlock from "./cta-block.component";

/**
 * An adapter for managing data & state for `CTABlock` component.
 * It should not take *any* product data props.
 *
 * @example
 * <CTABlockAdapter />
 */
export default function CTABlockAdapter() {
  const {
    deviceType: { isMobile, isTablet },
  } = useDeviceType();

  const variant = isMobile || isTablet ? "mobile" : "desktop";

  return <CTABlock variant={variant} />;
}
